import { Card, Typography } from "antd"
import { RxExternalLink } from 'react-icons/rx'
import PoskuImage from '../../assets/posku.png'
import AplotganaImage from '../../assets/aplotgana.png'

const { Link, Text } = Typography;

const { Meta } = Card;

function Project() {
    return (
        <div className="pt-10" id="project">
            <h1 className="text-gray-800 font-bold text-2xl my-6 pl-6 md:pl-0" data-aos="zoom-out" data-aos-duration="1500" data-aos-delay="100">Featured Projects</h1>
            <div className="grid grid-cols-1 md:grid-cols-2 items-center gap-6 items-center">
                <Card
                    style={{ width: 300, margin: 'auto' }}
                    cover={
                        <img
                            alt="example"
                            src={PoskuImage}
                        />
                    }
                    actions={[
                        <Link href="https://ngecash.id/" className="text-gray-500">
                            <RxExternalLink key="Visit" className="mx-auto" />
                            Visit
                        </Link>
                        // <Button type="text" className="text-gray-500">
                        //     <BiDetail key="Detail" className="mx-auto" />
                        //     Details
                        // </Button>
                    ]}
                    data-aos="zoom-out" data-aos-duration="1500" data-aos-delay="200"
                >
                    <Meta
                        title="NGECASH"
                        description="NGECASH is a web-based Point of Sale application used for recording sales transactions."
                    />
                    <div className="pt-6">
                        <Text className="mt-2 text-gray-300">
                            React Js, Express, MySQL, Tailwind
                        </Text>
                    </div>
                </Card>
                <Card
                    style={{ width: 300, margin: 'auto' }}
                    cover={
                        <img
                            alt="example"
                            src={AplotganaImage}
                        />
                    }
                    actions={[

                        <Link href="https://aplotgana.id/" className="text-gray-500">
                            <RxExternalLink key="Visit" className="mx-auto" />
                            Visit
                        </Link>
                        // <Button type="text" className="text-gray-500">
                        //     <BiDetail key="Detail" className="mx-auto" />
                        //     Details
                        // </Button>
                    ]}
                    data-aos="zoom-out" data-aos-duration="1500" data-aos-delay="200"
                >
                    <Meta
                        title="Aplotgana"
                        description="SAR Potential Activity Log Application for Disaster Response."
                    />
                    <div className="pt-6">
                        <Text className="mt-2 text-gray-300">
                            React Js, Express, MySQL, Tailwind
                        </Text>
                    </div>
                </Card>
                {/* <Card
                    style={{ width: 300, marginTop: 16 }}
                    actions={[
                        <a href="https://github.com/adamrayw/usedup">
                            <AiFillGithub key="Github" className="mx-auto my-2 w-4 h-4" />
                        </a>,
                        <a href="https://usedup.vercel.app/">
                            <RxExternalLink key="Visit" className="mx-auto my-2 w-4 h-4" />
                        </a>
                    ]}
                    data-aos="zoom-out" data-aos-duration="1500" data-aos-delay="400"
                >
                    <Meta
                        title="UsedUp"
                        description="UsedUp is a start-up company in the field of buying and selling used goods."
                    />
                    <div className="pt-6">
                        <p className="mt-2 text-gray-300">React Js, Express, Tailwind</p>
                    </div>
                </Card>
                <Card
                    style={{ width: 300, marginTop: 16 }}
                    actions={[
                        <a href="https://github.com/adamrayw/Wartegku">
                            <AiFillGithub key="Github" className="mx-auto my-2 w-4 h-4" />
                        </a>,
                        <a href="https://wartegku.vercel.app/">
                            <RxExternalLink key="Visit" className="mx-auto my-2 w-4 h-4" />
                        </a>
                    ]}
                    data-aos="zoom-out" data-aos-duration="1500" data-aos-delay="600"
                >
                    <Meta
                        title="Wartegku"
                        description="Beli makanan warteg tanpa keluar rumah"
                    />
                    <div className="pt-6">
                        <p className="mt-2 text-gray-300">React Js, Tailwind</p>
                    </div>
                </Card>
                <Card
                    style={{ width: 300, marginTop: 16 }}
                    actions={[
                        <a href="https://github.com/adamrayw/askme">
                            <AiFillGithub key="Github" className="mx-auto my-2 w-4 h-4" />
                        </a>,
                        <a href="https://askmee.vercel.app/">
                            <RxExternalLink key="Visit" className="mx-auto my-2 w-4 h-4" />
                        </a>,
                    ]}
                    data-aos="zoom-out" data-aos-duration="1500" data-aos-delay="600"
                >
                    <Meta
                        title="Askme"
                        description="Get secret feedback from your friends, without you knowing who they are."
                    />
                    <div className="pt-6">
                        <p className="mt-2 text-gray-300">React Js, Laravel</p>
                    </div>
                </Card> */}
            </div>

        </div>
    )
}

export default Project